module.exports = __webpack_public_path__ + "img/Cn.a89cf878.png";